<template>
  <div class="nav">

    <div class="desktop-nav hidden lg:block bg-lightdarkgrey py-6 px-4">
      <div class="grid grid-cols-5 w-full">
        <div class="col-span-3 col-start-2 flex justify-end items-center">
          <router-link to="/" v-slot="{ href, navigate, isExactActive }" custom>
            <a :href="href" @click="navigate" class="mr-5 nav-element" :class="(isExactActive ? 'active' : '')">Startseite</a>
          </router-link>
          <router-link to="/benchmarks" v-slot="{ href, navigate, isExactActive }" custom>
            <a :href="href" @click="navigate" class="mr-5 nav-element" :class="(isExactActive ? 'active' : '')">Benchmarking</a>
          </router-link>
          <router-link to="/profile" v-slot="{ href, navigate, isExactActive }" custom>
            <a :href="href" @click="navigate" class="mr-5 nav-element" :class="(isExactActive ? 'active' : '')">Mein Account</a>
          </router-link>
          <router-link to="/admin/user" v-slot="{ href, navigate, isExactActive }" custom>
            <a :href="href" @click="navigate" class="mr-5 nav-element" :class="(isExactActive ? 'active' : '')">User-Verwaltung</a>
          </router-link>
          <button class="button-color mr-0" @click="logout">Abmelden</button>
        </div>
      </div>
    </div>
    <div class="mobile-nav block lg:hidden bg-lightdarkgrey pt-10 pb-5 px-5">
      <div class="absolute left-4 top-4">
        <button class="text-white text-xl a border-white border-b-2" @click="mobileToggle = !mobileToggle">MENU</button>
        <div v-if="!mobileToggle" class="mobile-content bg-lightdarkgrey pl-5 pt-16 z-10">
          <div class="bg-lightdarkgrey pl-5">
            <div class="mb-5 text-lg">
              <router-link to="/" v-slot="{ href, navigate, isExactActive }" custom>
                <a :href="href" @click="navigate" :class="(isExactActive ? 'active' : '')">Startseite</a>
              </router-link>
            </div>
            <div class="mb-5 text-lg">
              <router-link to="/benchmarks" v-slot="{ href, navigate, isExactActive }" custom>
                <a :href="href" @click="navigate" :class="(isExactActive ? 'active' : '')">Benchmarking</a>
              </router-link>
            </div>
            <div class="mb-5 text-lg">
              <router-link to="/profile" v-slot="{ href, navigate, isExactActive }" custom>
                <a :href="href" @click="navigate" :class="(isExactActive ? 'active' : '')">Mein Account</a>
              </router-link>
            </div>
            <div class="mb-5 text-lg">
              <router-link to="/admin/user" v-slot="{ href, navigate, isExactActive }" custom>
                <a :href="href" @click="navigate" :class="(isExactActive ? 'active' : '')">User-Verwaltung</a>
              </router-link>
            </div>
          </div>
          <button class="button-color" @click="logout">Abmelden</button>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "Nav",
  data() {
    return {
      mobileToggle: true,
    };
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
      if (process.env.NODE_ENV !== "production") {
        this.$router.push("/login");
      } else {
        window.location.href = "/";
      }
    },
  },
};
</script>

<style scoped>
 .mobile-nav {
    width: 100vw;
  }

  .mobile-nav a {
    font-weight: 300;
  }

  .mobile-nav-item {
    font-size: 25px;
    font-weight: 300;
  }

  .nav button.button-color {
    color: white;
    box-shadow: 2px 1000px 1px #5c5c5c inset;
  }

  .mobile-nav .mobile-content {
    position: fixed;
    width: 100vw;
    height: 100vh;
    right: 0;
    overflow-y: scroll;
  }
</style>